import reducer from "../index"

jest.mock("model/updater", () => ({
  Types: {
    UPDATE_SUCCESS: "MOCKED_UPDATE_SUCCESS",
  },
}))

import { RECEIVE_USER } from "../../../actions/user"

describe("User reducer", () => {
  describe("on RECEIVE_USER", () => {
    it("populates the store with the user", () => {
      const user = { id: "test", name: "hello" }
      const action = {
        type: RECEIVE_USER,
        user,
      }
      const initialState = {}
      const newState = reducer(initialState, action)
      expect(newState).toEqual(user)
    })

    it("updates the existing user in the store", () => {
      const action = {
        type: RECEIVE_USER,
        user: { name: "new name" },
      }
      const initialState = { id: "test", name: "old name" }
      const newState = reducer(initialState, action)
      expect(newState).toEqual({ id: "test", name: "new name" })
    })
  })
})
